export default "__VITE_ASSET__C$gvS_Cc__"